import styled from '@emotion/styled';
import BlogReadGoodContentCard from '.';
import useGetRecommendationsPosts from '@hooks/fetch/spring/posts/useGetRecommendationsPosts';
import _ from 'lodash';

const BlogReadGoodContentCardListWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px;
  row-gap: 75px;
  flex-wrap: wrap;
`;

type Props = {
  language: 'KO' | 'EN';
  excludePostsId?: number;
  size?: number;
};

// TODO : Common Posts Type
const postsType = 'BLOG';

export default function BlogReadGoodContentCardList({ language, excludePostsId, size = 6 }: Props) {
  const { data } = useGetRecommendationsPosts({
    language,
    postsType,
  });
  const list = _.shuffle(excludePostsId ? data?.data?.filter((item) => item.id !== excludePostsId) : data?.data).slice(
    0,
    size,
  );

  return (
    <>
      <BlogReadGoodContentCardListWrapper>
        {list?.map((item) => (
          <BlogReadGoodContentCard key={item.id} data={item} />
        ))}
      </BlogReadGoodContentCardListWrapper>
    </>
  );
}
